import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { IsInvalidDirective } from '../../../../core/directives/is-invalid.directive';
import { NgForm } from '@angular/forms';
export class CollectionRowComponent {
    constructor(userService) {
        this.userService = userService;
        this.wasSubmitted = false;
        this.addNewMode = false;
        this.collChanged = new EventEmitter();
        this.onDelete = new EventEmitter();
    }
    get isEditing() {
        return !!this.original || this.addNewMode;
    }
    ngOnInit() {
        this.getCurrentUser();
    }
    edit() {
        this.original = this.coll;
        this.coll = Object.assign({}, this.coll);
    }
    revert() {
        this.coll = this.original;
        this.markClean();
    }
    apply() {
        if (this.isInvalidDirectives.some(value => value.isInvalid)) {
            this.wasSubmitted = true;
            return;
        }
        this.collChanged.emit(this.coll);
        this.markClean();
    }
    markClean() {
        this.original = undefined;
        this.form.control.markAsPristine();
        this.form.control.markAsUntouched();
        this.wasSubmitted = false;
    }
    getCurrentUser() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.currentUser = yield this.userService.getCurrentUserAsync();
        });
    }
}
